(() => {
  if (window.FFHomeInteractions) {
    window.FFHomeInteractions.refresh();
    return;
  }
  const finePointer = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 901px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let timers = [];
  const cards = '.ff-energy-world,.ff-lifestyle__card,.ff-product-card,.ff-content-card,.ff-service__item,.ff-solar-ecosystem__item';
  function reset() {
    observer?.disconnect();
    timers.forEach(clearTimeout);
    timers = [];
    document.body.classList.remove('ff-home-motion', 'ff-motion-hover-copy', 'ff-motion-linked', 'ff-home-integrated', 'ff-integrated-collapsible');
    document.body.style.removeProperty('--ff-motion-zoom');
    document.body.style.removeProperty('--ff-motion-product-zoom');
    document.querySelectorAll('.ff-motion-image-link,.ff-motion-corner,.ff-integrated-details').forEach(node => node.remove());
    document.querySelectorAll('.ff-integrated-open').forEach(node => node.classList.remove('ff-integrated-open'));
    document.querySelectorAll('.ff-integrated-story-details').forEach(node => { node.querySelector('summary')?.remove(); node.replaceWith(...node.childNodes); });
    document.querySelectorAll('.ff-motion-card,.ff-motion-secondary').forEach(node => node.classList.remove('ff-motion-card','ff-motion-secondary'));
    document.querySelectorAll('.ff-motion-entry,.ff-motion-pending').forEach(node => node.classList.remove('ff-motion-entry','ff-motion-pending'));
  }
  function refresh() {
    reset();
    const control = document.querySelector('[data-ff-home-interactions]');
    if (!control || control.dataset.enabled !== 'true') return;
    const calm = reducedMotion.matches;
    const editor = control.dataset.editor === 'true';
    const zoom = Math.max(0, Math.min(5, Number(control.dataset.zoom) || 0));
    document.body.classList.add('ff-home-motion');
    document.body.style.setProperty('--ff-motion-zoom', String(calm ? 1 : 1 + zoom / 100));
    document.body.style.setProperty('--ff-motion-product-zoom', String(calm ? 1 : 1 + Math.min(zoom, 2) / 100));
    document.body.classList.toggle('ff-motion-hover-copy', control.dataset.hoverCopy === 'true' && finePointer.matches && !calm && !editor);
    document.body.classList.toggle('ff-motion-linked', control.dataset.linkedCaptions === 'true');
    document.querySelectorAll(cards).forEach(node => node.classList.add('ff-motion-card'));
    document.querySelectorAll('.ff-energy-world__content > p:not(.ff-energy-world__kicker),.ff-lifestyle__content > p:not(.ff-lifestyle__replace),.ff-product-card__full-title,.ff-content-card__summary').forEach(node => node.classList.add('ff-motion-secondary'));
    document.querySelectorAll('.ff-lifestyle__card').forEach(card => {
      const media = card.querySelector('.ff-home-card-media');
      const link = card.querySelector('.ff-lifestyle__link');
      if (!media || !link || media.querySelector('.ff-motion-image-link')) return;
      const imageLink = document.createElement('a');
      imageLink.className = 'ff-motion-image-link';
      imageLink.href = link.href;
      imageLink.setAttribute('aria-label', card.querySelector('h3')?.textContent.trim() || link.textContent.trim());
      media.append(imageLink);
    });
    document.querySelectorAll('.ff-energy-world .ff-home-card-media,.ff-lifestyle__card .ff-home-card-media').forEach(media => {
      if (media.querySelector('.ff-motion-corner')) return;
      const corner = document.createElement('span');
      corner.className = 'ff-motion-corner';
      corner.setAttribute('aria-hidden','true');
      corner.textContent = '↗';
      media.append(corner);
    });

    const integrated = control.dataset.integrated === 'true';
    document.body.classList.toggle('ff-home-integrated', integrated);
    document.body.classList.toggle('ff-integrated-collapsible', integrated && control.dataset.hoverCopy === 'true' && !editor);
    if (integrated) {
      const backdropTargets = '.ff-story__inner';
      document.querySelectorAll(backdropTargets).forEach(node => {
        const image = node.querySelector('.ff-home-card-media img,.ff-story__media img');
        if (!image) return;
        const setBackdrop = () => node.style.setProperty('--ff-integrated-image', 'url(' + JSON.stringify(image.currentSrc || image.src) + ')');
        setBackdrop();
        if (!image.complete) image.addEventListener('load', setBackdrop, {once:true});
      });
      const integratedCards = [...document.querySelectorAll('.ff-energy-world,.ff-lifestyle__card')];
      integratedCards.forEach((card, index) => {
        const copy = card.querySelector('.ff-motion-secondary');
        const content = card.querySelector('.ff-energy-world__content,.ff-lifestyle__content');
        if (!copy || !content) return;
        copy.id = copy.id || 'ff-integrated-description-' + index;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ff-integrated-details';
        button.setAttribute('aria-expanded','false');
        button.setAttribute('aria-controls',copy.id);
        button.setAttribute('aria-label',(control.dataset.detailsLabel || 'Details') + ': ' + (card.querySelector('h3')?.textContent.trim() || ''));
        const label = document.createElement('span');
        label.textContent = control.dataset.detailsLabel || 'Details';
        const icon = document.createElement('span');
        icon.textContent = '+';
        icon.setAttribute('aria-hidden','true');
        button.append(label,icon);
        button.addEventListener('click', () => {
          const open = card.classList.toggle('ff-integrated-open');
          button.setAttribute('aria-expanded',String(open));
        });
        content.append(button);
      });
      document.querySelectorAll('.ff-story__copy').forEach(copy => {
        const remainder = [...copy.children].slice(1);
        if (!remainder.length) return;
        const details = document.createElement('details');
        details.className = 'ff-integrated-story-details';
        details.open = editor || calm;
        const summary = document.createElement('summary');
        summary.textContent = control.dataset.storyDetailsLabel || 'Read more';
        details.append(summary,...remainder);
        copy.append(details);
      });
    }

    if (control.dataset.entrance !== 'true' || calm || editor || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const node = entry.target;
        const siblings = [...node.parentElement.children];
        const delay = Math.min(siblings.indexOf(node), 3) * 65;
        timers.push(setTimeout(() => node.classList.remove('ff-motion-pending'), delay));
        observer.unobserve(node);
      });
    }, {threshold: 0.05, rootMargin: '0px 0px -20px 0px'});
    document.querySelectorAll('.ff-brand-home__section-head,.ff-energy-world,.ff-lifestyle__card,.ff-product-card,.ff-content-card,.ff-service__item,.ff-story__media,.ff-story__content').forEach(node => {
      if (node.getBoundingClientRect().top < innerHeight - 30 || !node.getClientRects().length) return;
      node.classList.add('ff-motion-entry','ff-motion-pending');
      observer.observe(node);
    });
  }
  finePointer.addEventListener('change', refresh);
  reducedMotion.addEventListener('change', refresh);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const card = event.target.closest?.('.ff-integrated-open');
    if (!card) return;
    card.classList.remove('ff-integrated-open');
    const button = card.querySelector('.ff-integrated-details');
    button?.setAttribute('aria-expanded','false');
    button?.focus();
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(refresh));
  window.FFHomeInteractions = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();


